import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { Animation } from '@ionic/core';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { AppCommonModule } from 'src/shared/common/common.module';
import {AddComponent} from '../pages/feed/components/add/add.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './components/app.component';
import { createTranslateLoader, NativeImports } from './config/native-add-on';

@NgModule({
  declarations: [AppComponent, AddComponent],
  entryComponents: [AddComponent],
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    IonicModule.forRoot({
      rippleEffect: false,
      mode: 'md',
      navAnimation: disableAnimation
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AppCommonModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    HttpClientModule,
    AppRoutingModule
  ],
  providers: [
    NativeImports,
    AngularFireAuth,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function disableAnimation(AnimationC: Animation): Promise<Animation> {
    return Promise.resolve(new AnimationC());
}
